const config = window.AbdelmegedTheme || {};
const storageKey = config.storageKeys?.sound || 'abdelmeged_sound';
const poolSize = 4;
const pools = new Map();
const poolIndexes = new Map();
const fallbackSoundUrl = `${(config.themeUrl || '').replace(/\/$/, '')}/assets/src/sound/mixkit-fast-double-click-on-mouse-275.wav`;
const soundSources = {
  reaction: config.soundUrls?.reaction || config.soundUrls?.tap || fallbackSoundUrl,
  tap: config.soundUrls?.tap || fallbackSoundUrl,
};
const soundVolumes = {
  reaction: 0.42,
  tap: 0.34,
};

const enabled = () => {
  try {
    const stored = localStorage.getItem(storageKey);

    return stored === null ? true : stored === 'on';
  } catch {
    return true;
  }
};

const setEnabled = (value) => {
  try {
    localStorage.setItem(storageKey, value ? 'on' : 'off');
  } catch {
    // Local storage may be unavailable in private contexts.
  }
};

const createAudio = (type) => {
  const source = soundSources[type] || soundSources.tap;

  if (!source) {
    return null;
  }

  const audio = new Audio(source);
  audio.preload = 'auto';
  audio.volume = soundVolumes[type] || soundVolumes.tap;

  return audio;
};

const audioPool = (type) => {
  const key = soundSources[type] ? type : 'tap';

  if (!pools.has(key)) {
    pools.set(key, Array.from({ length: poolSize }, () => createAudio(key)).filter(Boolean));
  }

  return pools.get(key);
};

const play = (type = 'tap') => {
  if (config.features?.sound !== true || !enabled()) {
    return;
  }

  const key = soundSources[type] ? type : 'tap';
  const pool = audioPool(key);

  if (!pool?.length) {
    return;
  }

  const nextIndex = poolIndexes.get(key) || 0;
  const audio = pool[nextIndex];
  poolIndexes.set(key, (nextIndex + 1) % pool.length);

  try {
    audio.currentTime = 0;
  } catch {
    // Some browsers disallow seeking before metadata is ready.
  }

  const playback = audio.play();

  if (playback && typeof playback.catch === 'function') {
    playback.catch(() => {
      // Browsers may still block sound before the first trusted interaction.
    });
  }
};

window.AbdelmegedSound = {
  enabled,
  setEnabled,
  play,
};

window.addEventListener('abdelmeged:interaction', (event) => {
  play(event.detail?.type);
});
